<!-- Макет: https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/002%2F1.-Элементы?type=design&node-id=8799-185065&mode=design&t=QIYkr2Df5aRVaiQq-0 -->
<template>
  <div class="goods-gallery">
    <div
      class="goods-gallery__items"
      :style="{
        'grid-template-columns': rowItemsColumns,
        '--aspect-ratio': `${rowItemsAspectRatio}`,
      }"
    >
      <GoodsGalleryItem
        v-for="item in rowItems"
        :key="item.image.url"
        :item="item"
        class="goods-gallery__item"
      />
    </div>

    <div
      class="goods-gallery__last-row"
      :style="{ '--aspect-ratio': lastRowItemsAspectRatio }"
    >
      <GoodsGalleryItem
        v-for="item in lastRowItems"
        :key="item.image.url"
        :item="item"
        class="goods-gallery__item"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import GoodsGalleryItem from './GoodsGalleryItem.vue';

  export type GoodsGalleryItem = {
    image: {
      url: string;
      width: number;
      height: number;
    };
    url: string;
    label?: string;
  };

  export const IS_BROWSER: boolean = typeof window !== 'undefined';

  export default defineNuxtComponent({
    name: 'GoodsGallery',

    components: { GoodsGalleryItem },

    props: {
      elem: {
        // @ts-ignore
        type: Object as PropType<TContent<{ items: GoodsGalleryItem[] }>>,
        required: true,
      },
    },

    data: () => ({
      tabletQuery: null as MediaQueryList | null,
      columns: 2,
    }),

    computed: {
      allItems(): GoodsGalleryItem[] {
        return this.elem.attributes.items;
      },

      lastRowItemsCount(): number {
        return this.allItems.length % this.columns;
      },

      rowItems(): GoodsGalleryItem[] {
        return this.allItems.slice(0, this.allItems.length - this.lastRowItemsCount);
      },

      rowItemsColumns(): string {
        return Array(this.columns).fill('1fr').join(' ');
      },

      lastRowItems(): GoodsGalleryItem[] {
        return this.allItems.slice(this.allItems.length - this.lastRowItemsCount);
      },

      rowItemsAspectRatio(): number {
        const shortestImage = [...this.rowItems].sort((a, b) => a.image.height - b.image.height)[0];

        return shortestImage?.image.width / shortestImage?.image.height || 1;
      },

      lastRowItemsAspectRatio(): number {
        const shortestImage = [...this.lastRowItems].sort(
          (a, b) => a.image.height - b.image.height,
        )[0];

        return shortestImage?.image.width / shortestImage?.image.height || 1;
      },
    },

    mounted() {
      this.tabletQuery = window.matchMedia('(min-width: 768px)');
      this.columns = this.tabletQuery.matches ? 3 : 2;
      this.tabletQuery.addEventListener('change', this.watchTabletMedia);
    },

    unmounted() {
      this.tabletQuery?.removeEventListener('change', this.watchTabletMedia);
    },

    methods: {
      watchTabletMedia(event: MediaQueryListEvent): void {
        this.columns = event.matches ? 3 : 2;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .goods-gallery {
    margin: 24px 0;

    &__items,
    &__last-row {
      display: grid;
      gap: 16px 8px;

      @include tablet {
        gap: 24px 12px;
      }
    }

    &__last-row {
      display: flex;
    }

    &__items:not(:empty) {
      margin-bottom: 16px;

      @include tablet {
        margin-bottom: 24px;
      }
    }
  }
</style>
